import { useEffect, useState, useMemo } from 'react';
import { Row,Container } from 'react-bootstrap';
import _isEmpty from 'lodash/isEmpty';
import compose from 'recompose/compose';
import { actions } from '../../components/Cards/PrintQR/config';
import { mapStateToProps, mapDispatchToProps } from '../TableAdmin/MyGiftTable/storeProps';
import { Link, useHistory } from 'react-router-dom';
import { useStore } from 'store';
import { resetGifts } from 'store/actions/gifts/actions';
import { withAgentPage, withLayout } from 'hocs';
import { Formik, useField, useFormikContext , withFormik } from 'formik'; 
import arrow from 'assets/img/arrow.svg';
import GiftsTable from 'pages/TableAdmin/MyGiftTable';
import ClosedTableMessage from 'components/gifts-table/ClosedTableMessage';
import { withStore } from 'store';
import styles from './styles.module.scss';
import { useStorage64Latin, useWindowSize } from 'hooks';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { SEARS_PRODUCT, TOTAL_GIFT_TABLES } from 'constants/storage64';
import { encodeStorage, decodeStorage } from 'functions/storageBase64';
import { CustomIcon, Modal, ModalQR } from 'components';
import ScannerQr from 'components/Cards/PrintQR/ScannerQr';
import ScannerQrMobile from 'components/Cards/PrintQR/ScannerQrMobile';
import GiftItem from 'components/gifts-table/GiftsList/GiftItem'
import _get from 'lodash/get';
import { getProductsById, getProductsBySku } from 'services/api/products';
import { HeaderMobile } from 'components/Mobile';
import { hideLoader, showLoader } from 'store/actions/commons';

import { mapPropsToValues } from '../TableAdmin/MyGiftTable/formikProps';
import { getProductDetails } from 'services/gifts';



function AddGiftsMobile({
  onClickItem,
  giftTableProducts,
  addProduct,
  deleteProduct,
}) {
  const [size, setSize] = useState('');
  const [sku, setSku] = useState(0);
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [storageGiftTable] = useStorage64Latin(CURRENT_GIFT_TABLE, {});
  const selected = _get(giftTableProducts, 'results.allElements', []);

  const [, dispatch] = useStore((state) => state.giftTable.giftTable);
  useEffect(() => () => dispatch(resetGifts()), []);
  const [closeModal, setcloseModal] = useState(true)
  const handleClose = () => {
    setcloseModal(false);
  };

  const history = useHistory();
  const handleSetProductos = (data) => {
    setProducts(data);
  };


  const handleAddProduct = async (product) => {
    const response = await getProductsById([product.id]);
    const detail = response && response.data.length ? response.data[0] : null;
    const variant = detail?.variations?.filter(v => v.sku === product.variant);
    product.variant_id = variant?.length ? variant[0].id : null;
    product.children_sku = variant?.length ? variant[0].sku : null;
    product.ean = detail?.ean;
    product.sku = detail?.sku;

    addProduct(product);
  };

  const handleDeleteProduct = (product) => {
    deleteProduct({ tableId: storageGiftTable.id, productId: product.id });
  };
  
  const handleCloseModal = () => {
    setcloseModal(true);
  };

  const handleShowAnotherScan = () => {
    setcloseModal(true);
  }

  return (
    <section>
    <HeaderMobile title="" accion={handleShowAnotherScan}/>

    <div className={styles.container}>
      <Modal
        actionClose = { () => history.goBack() }
        title="Escanear productos"
        titleClassName="col-md-12 offset-md-1"
        show={closeModal}
        withActionButtons={false}
      >
        <ScannerQrMobile  handleClose={handleClose} handleSetProductos={handleSetProductos} />
      </Modal>

      {products && products.length !== 0 && (
              products.map((giftProduct) => {
                const isSelected = selected.find(
                    ({ id }) => Number(id) === Number(giftProduct.id)
                );
               
                return (
                    <GiftItem
                        onClickGift={onClickItem}
                        onAddGift={handleAddProduct}
                        onDeleteGift={handleDeleteProduct}
                        id={giftProduct.id}
                        item={giftProduct}
                        selected={isSelected}
                        quantity={isSelected?.quantity || 0}
                        showBigPrice
                        bigRenderClassName={styles.GiftItemInModal}
                        productDetailsClassName={styles.productDetails}
                        className={styles.GiftItemInModal}
                        giftTableId={storageGiftTable.evento}
                        showSuccessModal
                        type={'mobileDetails'}
                        sku={sku}
                        wantedSize={size}
                        showAnotherScan={handleShowAnotherScan}
                        onCancelScan={handleCloseModal}
                        showAllImages={true}
                    />
                );
              })
          )}
      
    </div>
    </section>
  );
  
}

export default compose(
  withStore({ mapStateToProps, mapDispatchToProps }),
  withFormik({ mapPropsToValues })
)(AddGiftsMobile);

